module.exports = [
  {
    key: 'SIT',
    label: {
      en: 'Seated Forward',
      es: 'Sentado mirando hacia adelante',
    },
  },
  {
    key: 'LAY',
    label: {
      en: 'Supine',
      es: 'Acostado',
    },
  },
  {
    key: 'FOWLER',
    label: {
      en: 'Fowler',
      es: 'Fowler',
    },
  },
  {
    key: 'PRONE',
    label: {
      en: 'Prone',
      es: 'Propensa',
    },
  },
  {
    key: 'SIDE',
    label: {
      en: 'Side',
      es: 'Lado',
    },
  },
];
